'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'sun-bright';
var width = 512;
var height = 512;
var aliases = ["sun-alt"];
var unicode = 'e28f';
var svgPathData = ['M192 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z', 'M280 24l0 64 0 24-48 0 0-24 0-64 0-24 48 0 0 24zm157 84.9l-45.3 45.3-17 17-33.9-33.9 17-17L403.1 75l17-17L454 92l-17 17zM108.9 75l45.3 45.3 17 17-33.9 33.9-17-17L75 108.9 58 92 92 58l17 17zM24 232l64 0 24 0 0 48-24 0-64 0L0 280l0-48 24 0zm400 0l64 0 24 0 0 48-24 0-64 0-24 0 0-48 24 0zM154.2 391.8L108.9 437 92 454 58 420l17-17 45.3-45.3 17-17 33.9 33.9-17 17zm237.6-33.9L437 403.1l17 17L420 454l-17-17-45.3-45.3-17-17 33.9-33.9 17 17zM280 424l0 64 0 24-48 0 0-24 0-64 0-24 48 0 0 24zm40-168a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-176 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunBright = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;